import { useEffect } from "react"

export default ({
  state,
  onChangeRecruiterType,
  onChangeIndustry,
  onChangeCompanySize,
}) => {
  useEffect(() => {
    if (state.loading) return

    onChangeRecruiterType(state.benchmarkSettings.recruiterType)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.benchmarkSettings.recruiterType, state.loading])
  useEffect(() => {
    if (state.loading) return

    onChangeIndustry(state.benchmarkSettings.industry?.id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.benchmarkSettings.industry, state.loading])
  useEffect(() => {
    if (state.loading) return

    onChangeCompanySize(state.benchmarkSettings.companySize?.id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.benchmarkSettings.companySize, state.loading])
}
